import React, { useEffect, useState } from 'react';
import * as ethers from "ethers";
import config from "../../config";
import moment from "moment";

const Pot = (props: any) => {

  const [value, setValue] = useState<any>(0)

  const setGenValue = (e: any) => {
    let val = parseInt(e.target.value);
    let availablePotsByGen = props.pots - value;
    let availablePots = props.maxPots - props.usedPots;
    if (isNaN(val)) setValue('');
    if (val < props.usedPots) { setValue(val); return false };
    if (props.allUsedPots >= props.maxPots) return false;
    if (val <= props.maxPots && val <= props.pots) { setValue(val); return false };
    if (val > props.maxPots || val > props.pots) { setValue(availablePotsByGen > props.maxPots ? value + availablePots : value + availablePotsByGen); return false };
    if (props.usedPots + val > props.maxPots) {
      val = props.maxPots - props.usedPots > props.pots ? props.pots : props.maxPots - props.usedPots;
      setValue(val)
    }
  }

  const getDate = (gen: any) => {
    switch (gen + 1) {
      case 1:
        return "March 5";
      case 2:
        return "March 12";
      case 3:
        return "March 19";
      case 4:
        return "April 2";
      case 5:
        return "April 9";
      case 6:
        return "None";
    }
  }

  useEffect(() => {
    props.updatePots(value, props.gen)
  }, [value]);

  useEffect(() => {
    setValue(props.value)
  }, [props.value]);

  return (
    <div className='pot-control'>
      <p>{getDate(props.gen)}</p>
      <img src={require("../../assets/pot.png").default} alt="" />
      <p>{`${props.pots} Gen${props.gen + 1}`}</p>
      {props.gen > 4 ? <input onChange={(e: any) => setGenValue(e)} type="number" max={props.pots} min={0} value={value ? value : ''} /> : <div>Expired</div>}
    </div>
  );
};

export default Pot;
